import React, { useState } from 'react';
import NavTab from './nav_tab';

const Sidebar = ({ options, pendingCount, setTab, tab, closeInviteTab, resetSearchInput }) => {
  const navBarTabs = options;
  const [showDropdown, setShowDropdown] = useState(false);

  const handleSelection = (tab) => {
    setTab(tab);
    closeInviteTab(false);
    resetSearchInput(true);
    setShowDropdown(false);
  };

  const createTabs = () => {
    return navBarTabs.map((navBarTab, idx) => (
        < NavTab
          key={navBarTab + String(idx)}
          tab={navBarTab}
          onClick={() => handleSelection(navBarTab)}
          selected={navBarTab === tab}
          className="dropdown-item"
          pendingCount={pendingCount}
        />
    ));
  };

  const menuStyles = () => {
    const styles = { zIndex: 2000 };
    styles.display = showDropdown ? 'block' : 'none';
    return styles;
  };

  return (
    <>
      <aside className="border rounded-2 col-md-3 d-none d-md-block sidebar-nav ms-4">
        <ul className="ps-5 nav flex-column">
          {createTabs(navBarTabs)}
        </ul>
      </aside>
      <aside className="dropdown border rounded-2 col-md-2 d-block d-md-none sidebar-nav mt-11 border-top-0">
        <button className="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" onClick={(() => setShowDropdown(!showDropdown))} >
          Menu
        </button>
          <ul className="ps-2 nav flex-column dropdown-menu" style={menuStyles()}>
            {createTabs(navBarTabs)}
          </ul>
      </aside>
    </>
  );
};

export default Sidebar;
